export const sundayUppercase = "ACTw_c";
export default {sundayUppercase};